import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SharedModule } from '@/shared.module';

/**
 * Read-only dialog explaining how to fill in the notes textarea of a
 * zorgresultaat: what to write about the baseline, the target and the
 * zorgvrager context, and why. Opened from the info icon in the results
 * section; closes without a result.
 */
@Component({
  selector: 'app-nnn-results-info-dialog',
  standalone: true,
  imports: [SharedModule],
  templateUrl: './nnn-results-info-dialog.component.html',
  styleUrl: './nnn-results-info-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NnnResultsInfoDialogComponent {
  protected readonly sections = ['baseline', 'target', 'context'] as const;
}
